export default __webpack_public_path__ + "static/media/titolari.27f9eff1.png";